import styled from 'styled-components';

export const Wrapper = styled.label<{ disabled?: boolean }>`
  display: flex;
  align-items: center;
  text-align: left;
  gap: ${({ theme }): string => theme.spacing_unit_x2};
  color: ${({ theme, disabled }): string =>
    disabled === true ? theme.palette_gray_60 : 'inherit'};
`;

export const Input = styled.input<{ disabled?: boolean }>`
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  position: relative;
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  box-sizing: border-box;
  border-width: 2px;
  border-style: solid;
  border-color: ${({ theme }): string => theme.palette_gray_40};
  border-radius: ${({ theme }): string => theme.border_radius_x1};
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }): string => theme.palette_white};

  &:checked {
    border-color: ${({ theme, disabled }): string =>
      disabled === true ? theme.palette_gray_60 : theme.palette_blue_100};
    background-color: ${({ theme, disabled }): string =>
      disabled === true ? theme.palette_gray_60 : theme.palette_blue_100};
  }

  &:checked::after {
    content: '';
    position: absolute;
    width: 18px;
    height: 18px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    background-image: url("data:image/svg+xml,%3Csvg width='18' height='14' viewBox='0 0 18 14' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M5.79508 10.8749L1.62508 6.70492L0.205078 8.11492L5.79508 13.7049L17.7951 1.70492L16.3851 0.294922L5.79508 10.8749Z' fill='white'/%3E%3C/svg%3E%0A");
  }
`;
